import { TemplatedProjectParameters, type TemplatedProjectParametersLoaderData } from "./TemplatedProjectParameters";
export interface BranchTemplatedProjectParametersProps {
    loaderData: TemplatedProjectParametersLoaderData;
}
export function BranchTemplatedProjectParameters({ loaderData }: BranchTemplatedProjectParametersProps) {
    return <TemplatedProjectParameters loaderData={loaderData}/>;
}
